<div [formGroup]="formGroup">
  <sc-string-field labelDictionaryKey="tmc-yard.entity.transport.masterdata.reference" formControlName="value"></sc-string-field>
</div>
